var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM16.19 18H16.18C15.77 18 15.41 17.74 15.27 17.36L14.42 14.94H9.58L8.72 17.37C8.58 17.74 8.22 18 7.82 18H7.8C7.13 18 6.67 17.33 6.9 16.7L10.55 7C10.78 6.4 11.35 6 12 6C12.65 6 13.22 6.4 13.45 7L17.09 16.7C17.33 17.33 16.86 18 16.19 18ZM10.2 13.19L11.95 8.23H12.05L13.79 13.19H10.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "rgba(0,27,83,0.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageText);
export default __webpack_public_path__ + "static/media/landingPageText.adce6f6b6379d0ad98b46666ab6b28fd.svg";
export { ForwardRef as ReactComponent };